// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"u1-z"};